import { with1ezpy3gn0rpui as with_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PartyId.mjs';
import { SavePinMutation3865jhueq4vmv as SavePinMutation } from './schema/SavePinMutation.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instance387j2kbgg1xpz as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SavePinInputnc3r3ek8pldn as SavePinInput } from './schema/type/SavePinInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  var partyId = command.component1_7eebsc_k$();
  var pin = command.component2_7eebsb_k$();
  yield* this.execute_csffyb_k$(new (SavePinMutation())(savePinInput(with_0(partyId, pin))), $completion);
  return Accepted_instance;
}
var SdkSavePinCommandDispatcherClass;
function SdkSavePinCommandDispatcher() {
  if (SdkSavePinCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePinCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePinCommandDispatcherClass = $;
  }
  return SdkSavePinCommandDispatcherClass;
}
function savePinInput(_this__u8e3s4) {
  return new (SavePinInput())(_this__u8e3s4.partyId_1, _this__u8e3s4.element_1.id_1, _this__u8e3s4.element_1.icon_1, _this__u8e3s4.element_1.name_1);
}
//region block: exports
export {
  SdkSavePinCommandDispatcher as SdkSavePinCommandDispatcher1w2xmq7bhdmfl,
  perform as perform21g4sd216edkg,
};
//endregion

//# sourceMappingURL=SdkSavePinCommandDispatcher.mjs.map
